import cn from 'classnames';
import BellIcon from '@/assets/icon/components/BellIcon';
import styles from './notificationBell.module.scss';

interface INotificationBellProps {
  count: number;
  isActive: boolean;
  onClick: () => void;
}

const MAX_BADGE_COUNT = 99;

/**
 * Кнопка-колокольчик в шапке с бейджем непрочитанных. Число берётся из
 * `unviewedOrders` (единый источник с фавиконом). Клик открывает/закрывает
 * панель уведомлений.
 */
export const NotificationBell: React.FC<INotificationBellProps> = ({
  count,
  isActive,
  onClick
}) => {
  const badgeLabel = count > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : count;

  return (
    <button
      type="button"
      className={cn(styles['notification-bell'], {
        [styles['notification-bell_active']]: isActive
      })}
      onClick={onClick}
      aria-label="Уведомления"
      aria-expanded={isActive}
      title="Уведомления"
    >
      <BellIcon width={20} height={20} color="#fff" />
      {count > 0 && (
        <span className={styles['notification-bell__badge']}>{badgeLabel}</span>
      )}
    </button>
  );
};
